document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  var form = document.querySelector('.ar-product-v10__form');
  var dialog = document.querySelector('[data-ar28-pair-dialog]');
  if (!form || !dialog || !window.fetch || typeof dialog.showModal !== 'function') return;
  var close = dialog.querySelector('[data-ar28-close]');
  var addPair = dialog.querySelector('[data-ar28-pair-add]');
  var feedback = dialog.querySelector('[data-ar28-pair-feedback]');
  var pairSelect = dialog.querySelector('[data-ar28-pair-variant]');
  if (pairSelect && addPair) pairSelect.addEventListener('change', function () { addPair.disabled = !Number(pairSelect.value); });
  var busy = false;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function cartUrl() { return root + 'cart'; }
  function refreshCount() {
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var badge = document.querySelector('.ar22-header__bag .ar22-header__count');
      var bag = document.querySelector('.ar22-header__bag');
      if (!bag) return;
      if (!badge && cart.item_count) { badge = document.createElement('span'); badge.className = 'ar22-header__count'; bag.appendChild(badge); }
      if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
      bag.setAttribute('aria-label', 'Warenkorb öffnen, ' + cart.item_count + ' Artikel');
    }).catch(function () {});
  }
  function add(variantId, quantity) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('Warenkorb konnte nicht aktualisiert werden'); return r.json(); });
  }
  form.addEventListener('submit', function (event) {
    if (event.defaultPrevented) return;
    if (busy) { event.preventDefault(); return; }
    var input = form.querySelector('[data-ar-variant-id]');
    var qty = form.querySelector('input[name="quantity"]');
    var submitter = event.submitter;
    if (submitter && submitter.name && submitter.name !== 'add') return;
    if (!input || !Number(input.value)) return;
    event.preventDefault();
    busy = true;
    var original = form.querySelector('[data-ar-add-button]');
    if (original) original.disabled = true;
    add(input.value, qty ? qty.value : 1).then(function () {
      refreshCount();
      if (feedback) feedback.textContent = '';
      dialog.showModal();
    }).catch(function () {
      form.submit();
    }).finally(function () {
      busy = false;
      if (original) original.disabled = false;
    });
  });
  if (close) close.addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
  if (addPair) addPair.addEventListener('click', function () {
    var variantId = pairSelect ? Number(pairSelect.value) : Number(addPair.getAttribute('data-variant-id'));
    if (!variantId && feedback) feedback.textContent = 'Bitte wähle zuerst eine Größe.';
    if (!variantId) return;
    addPair.disabled = true;
    if (feedback) feedback.textContent = 'Wird hinzugefügt …';
    add(variantId, 1).then(function () { window.location.assign(cartUrl()); }).catch(function () {
      if (feedback) feedback.textContent = 'Das hat leider nicht geklappt. Du kannst den Artikel auch einzeln öffnen.';
      addPair.disabled = false;
    });
  });
});